import React, { useEffect, useRef } from "react";
import "./Content_1.css";
import PlatformViz from "./viz/PlatformViz";

const Content = () => {
  const sectionRef = useRef(null);
  const panelRef = useRef(null);

  // Fade/lift the minimalist headline out as the ecosystem is revealed.
  useEffect(() => {
    const section = sectionRef.current;
    const panel = panelRef.current;
    if (!section || !panel) return undefined;

    let scheduled = false;
    const apply = () => {
      scheduled = false;
      const rect = section.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      // fully visible until ~10% scrolled, gone by ~42%
      const fade = 1 - Math.min(1, Math.max(0, (p - 0.1) / 0.32));
      panel.style.setProperty("--panel-fade", fade.toFixed(3));
    };
    const onScroll = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    };
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section ref={sectionRef} className="nz-content">
      <div className="nz-content__stage">
        <PlatformViz className="nz-content__viz" />
        <div className="nz-content__overlay" />
        <div ref={panelRef} className="nz-content__wrap">
          <div className="nz-content__headline">
            <span className="nz-content__kicker" data-aos="nz-rise" data-aos-delay="100">
              One Platform
            </span>
            <h2 className="nz-content__title" data-aos="nz-rise" data-aos-delay="160">
              Your Business, Our Platform
            </h2>
            <p className="nz-content__text" data-aos="nz-rise" data-aos-delay="240">
              empowering your operations and back-office with our various solutions <br/> an
              efficient single platform from sales and operations integrated to financial
              accounting.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Content;
